import React, { useState } from 'react';
import { Box, Typography, Button, TextField, Popover } from "@mui/material";
import axios from '../../hooks/fetchWithAuth';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from "@mui/icons-material/Add";
import ConfirmationDialog from '../Confirmation';
import Card from '../Card/Card';
import config from '../../config';
import StrictModeDroppable from '../StrictModeDroppable';
import Note from '../Note/Note';
import './CardList.css';
import getCookie from '../../hooks/getCookie';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import { Draggable } from 'react-beautiful-dnd';
import EditIcon from '@mui/icons-material/Edit';
import ChecklistIcon from '@mui/icons-material/Checklist';
import DeleteIcon from '@mui/icons-material/Delete';
import Alerts2 from '../Alert2';

function CardList({
    list,
    index,
    openList,
    anchorEl,
    handlePopoverOpen,
    handlePopoverClose,
    isEditing2,
    editRef,
    newTitle,
    handleTitleChangeList,
    handleTitleSubmitList,
    handleColorListRemove,
    isCopyingList,
    selectedListName,
    handleTitleCopyList,
    addList,
    dialogOpenLista,
    setDialogOpenLista,
    handleDeleteList,
    selectedListId,
    handleEditListClick,
    handleNewTitleClick,
    addingCard,
    handleCardNameChange,
    handleCardNameKeyPress,
    handleAddCardClick,
    handleAddNoteClick,
    coverColor,
    coverImage,
    openModal,
    tagsInCards,
    commentsCount,
    archivesCount,
    progressTasks,
    usersInCards,
    showArchiveList,
    setAddingCard,
    setAddingNote,
    notes,
    handleNoteNameChange,
    handleNoteNameKeyPress,
    addingNote,
    openNoteModal,
    onUpdateNote,
    background_color,
    setColumns,
    isCollapsed,
    onToggleCollapse,
    isDarkMode,
    fetchTiBoardData,
    fetchNotes,
    showAlert,
}) {
    // Estado para controlar o menu de adicionar
    const [showAddActions, setShowAddActions] = React.useState(false);
    // Junta cards e notes, ordenando pelo campo 'order'
    const items = [
        ...(notes || []).map(note => ({ ...note, _type: 'note' })),
        ...(list.cards || []).map(card => ({ ...card, _type: 'card' })),
    ].sort((a, b) => (a.order || 0) - (b.order || 0));

    const [alert2, setAlert2] = React.useState(null);
    const backendIp = config.backend_ip;
    const username = getCookie('username');
    const sessionId = getCookie('session_id');
    const [selectedColor, setSelectedColor] = useState('');
    const colorPalette = [
        '#164b35',
        '#533f04',
        '#702e00',
        '#5d1f1a',
        '#352c63',
        '#09326c',
        '#164555',
        '#37471f',
        '#50253f',
        '#596773'
    ];
    const handleColorList = async (color) => {
        setSelectedColor(color);

        setColumns(prev => {
            const updated = prev.map(col =>
                col.list_id === selectedListId
                    ? { ...col, background_color: color }
                    : col
            );
            return updated;
        });

        try {
            await axios.put(`${backendIp}/api/board/ti/update_list`, {
                background_color: color,
                list_id: selectedListId,
                user: username,
                session_id: sessionId
            });
        } catch (error) {
            return null;
        }
    };
    const handleRemoveCover = async () => {
        try {
            await axios.put(`${backendIp}/api/board/ti/update_list`, {
                list_id: selectedListId,
                background_color: '',
                user: username,
                session_id: sessionId,
            });
        } catch (error) {
            return null;
        }
    };
    function lightenColor(color, percent = 10, alpha = 0.9) {
        // Se a cor já for rgba, extrai os canais e aplica o clareamento
        if (color.startsWith('rgba')) {
            const match = color.match(/rgba\(([^,]+),([^,]+),([^,]+),([^)]+)\)/);
            if (!match) return color; // fallback
            let r = parseInt(match[1]);
            let g = parseInt(match[2]);
            let b = parseInt(match[3]);
            // clareia cada canal
            r = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
            g = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
            b = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));
            return `rgba(${r},${g},${b},${alpha})`;
        }
        // Se for rgb
        else if (color.startsWith('rgb')) {
            const match = color.match(/rgb\(([^,]+),([^,]+),([^,]+)\)/);
            if (!match) return color;
            let r = parseInt(match[1]);
            let g = parseInt(match[2]);
            let b = parseInt(match[3]);
            r = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
            g = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
            b = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));
            return `rgba(${r},${g},${b},${alpha})`;
        }
        // Se for hex
        else {
            let hex = color.replace(/^#/, '');
            if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
            const num = parseInt(hex, 16);
            let r = (num >> 16) & 0xFF;
            let g = (num >> 8) & 0xFF;
            let b = num & 0xFF;
            r = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
            g = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
            b = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));
            return `rgba(${r},${g},${b},${alpha})`;
        }
    }

    // const handleDeleteNote = (noteId) => {
    //     // Atualiza as notas imediatamente após exclusão
    //     if (fetchNotes) fetchNotes();
    // };

    return (
        <Draggable draggableId={`list-${list.list_id}`} index={index}>
            {(provided, snapshot) => (
                <Box
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    // {...provided.dragHandleProps}
                    key={list.list_id}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        maxHeight: '100%',
                        ...provided.draggableProps.style
                    }}
                >
                    {list.list_name === "Arquivado" && !showArchiveList ? null : (
                        <StrictModeDroppable droppableId={list.list_id.toString()} key={list.list_id}>
                            {(droppableProvided) => (
                                <Box
                                    className={`column-container ${isCollapsed ? 'collapsed' : ''} ${snapshot.isDragging ? 'dragging' : ''}`}
                                    ref={droppableProvided.innerRef}
                                    {...droppableProvided.droppableProps}
                                    sx={{
                                        backgroundColor: `${list.background_color} !important`,
                                        width: isCollapsed ? '60px' : 'fit-content',
                                        minWidth: isCollapsed ? '60px' : '250px',
                                        transform: snapshot.isDragging ? 'rotate(5deg)' : 'none',
                                    }}
                                >
                                    <div
                                        {...provided.dragHandleProps}
                                        style={{
                                            display: 'flex',
                                            width: isCollapsed ? '50px' : '90%',
                                            alignItems: 'center',
                                            marginBottom: '10px',
                                            borderBottom: '2px solid #cebcbc2c',
                                            paddingBottom: '5px',
                                            cursor: 'grab',
                                            userSelect: 'none'

                                        }}
                                        onMouseDown={(e) => {
                                            // Previne interferência com outros elementos
                                            e.stopPropagation();
                                        }}
                                    >
                                        <div
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                // Só expande se estiver colapsada E se a lista NÃO estiver sendo arrastada
                                                if (isCollapsed && !snapshot.isDragging) {
                                                    onToggleCollapse();
                                                }
                                            }}
                                            style={{
                                                flex: 1,
                                                textAlign: 'center',
                                                cursor: isCollapsed ? 'pointer' : 'inherit',
                                                pointerEvents: 'auto'
                                            }}
                                        >
                                            <Typography
                                                variant="h7"
                                                className='title-list'
                                                style={{
                                                    writingMode: isCollapsed ? 'vertical-rl' : 'horizontal-tb',
                                                    textOrientation: isCollapsed ? 'mixed' : 'initial',
                                                    fontSize: isCollapsed ? '12px' : 'inherit',
                                                    pointerEvents: 'none',
                                                    ...(list.background_color && { color: lightenColor(list.background_color, 75) })
                                                }}
                                            >
                                                {isCollapsed
                                                    ? list.list_name.slice(0, 10) + (list.list_name.length > 10 ? '...' : '')
                                                    : list.list_name
                                                }
                                            </Typography>
                                        </div>
                                        {!isCollapsed && (
                                            <div style={{ pointerEvents: 'auto' }}>
                                                <CloseFullscreenIcon
                                                    style={{ cursor: 'pointer', fontSize: '18px', marginRight: '5px', ...(list.background_color && { color: lightenColor(list.background_color, 75) }) }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onToggleCollapse();
                                                    }}
                                                />
                                                {list.list_name !== "Arquivado" && (
                                                <MoreVertIcon
                                                    className='icon-dots'
                                                    style={{ ...(list.background_color && { color: lightenColor(list.background_color, 75) }) }}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        handlePopoverOpen(event, list.list_id, list.list_name);
                                                    }}
                                                />
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    {isCollapsed && (
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                gap: '5px',
                                                marginBottom: '10px',
                                                cursor: 'pointer'
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onToggleCollapse();
                                            }}
                                        >
                                            <div className='title-list-length'
                                                style={{
                                                    ...(list.background_color && { color: lightenColor(list.background_color, 75) })
                                                }}>
                                                {(list.cards?.length || 0) + (notes?.length || 0)}
                                            </div>
                                        </div>
                                    )}

                                    <Popover
                                        open={openList}
                                        anchorEl={anchorEl}
                                        onClose={handlePopoverClose}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        PaperProps={{
                                            sx: {
                                                backgroundColor: 'var(--bg-secondary, #ffffff)',
                                                border: '2px solid var(--primary-color, #0079bf)',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.18)',
                                                minWidth: '150px',
                                                overflow: 'hidden',
                                            },
                                            className: 'custom-popover-paper',
                                        }}
                                    >
                                        {isEditing2 ? (
                                            <Box sx={{ p: 2, maxWidth: '350px' }} ref={editRef}>
                                                <Typography sx={{
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    color: 'var(--text-primary, #172b4d)',
                                                    mb: 1.5,
                                                    textAlign: 'center'
                                                }}>
                                                    Editar Lista
                                                </Typography>
                                                <TextField
                                                    value={newTitle || selectedListName}
                                                    onChange={handleTitleChangeList}
                                                    variant="outlined"
                                                    size="small"
                                                    className='input-edit-list'
                                                    sx={{
                                                        width: '100%',
                                                        mb: 1.5,
                                                        '& .MuiOutlinedInput-root': {
                                                            color: 'var(--textfield-text-color, #000)',
                                                            backgroundColor: 'var(--textfield-bg-color, #fff)',
                                                            borderRadius: '6px',
                                                            fontSize: '14px',
                                                            '& fieldset': {
                                                                borderColor: 'var(--textfield-border-color, #ccc)',
                                                            },
                                                            '@media (prefers-color-scheme: dark)': {
                                                                '& .MuiOutlinedInput-root fieldset': {
                                                                    borderColor: '#575757',
                                                                },
                                                            },
                                                        },
                                                        '& .MuiInputLabel-root': {
                                                            color: 'var(--textfield-label-color, #000)',
                                                        },
                                                        '& .Mui-focused .MuiInputLabel-root': {
                                                            color: 'var(--textfield-label-focus-color, #009373)',
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            color: 'var(--textfield-text-color, #000)',
                                                            padding: '8px 10px',
                                                        },
                                                    }}
                                                />
                                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 40px)', gap: '10px', alignItems: 'center', justifyContent: 'center', padding: '10px', marginBottom: '8px' }}>
                                                    {colorPalette.map((color, index) => (
                                                        <div
                                                            key={index}
                                                            onClick={() => handleColorList(color)}
                                                            style={{
                                                                backgroundColor: color,
                                                                width: '40px',
                                                                height: '30px',
                                                                cursor: 'pointer',
                                                                border: selectedColor === color ? '1px solid white' : 'none',
                                                                borderRadius: '5px',
                                                            }}
                                                        ></div>
                                                    ))}
                                                </div>
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => {
                                                            handleTitleSubmitList(selectedListId);
                                                            handlePopoverClose();
                                                        }}
                                                        className="button-popover-green"
                                                        sx={{
                                                            flex: 1,
                                                            fontSize: '13px',
                                                            fontWeight: 600,
                                                            textTransform: 'none',
                                                            borderRadius: '6px',
                                                            padding: '6px 12px',
                                                        }}
                                                    >
                                                        Salvar
                                                    </Button>
                                                    <Button
                                                        variant="outlined"
                                                        onClick={() => {
                                                            handleColorListRemove(selectedListId);
                                                            handlePopoverClose();
                                                        }}
                                                        className="button-cancel-popover"
                                                        color='error'
                                                        sx={{
                                                            flex: 1,
                                                            fontSize: '13px',
                                                            fontWeight: 600,
                                                            textTransform: 'none',
                                                            borderRadius: '6px',
                                                            padding: '6px 12px',
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(211, 47, 47, 0.1)'
                                                            }
                                                        }}
                                                    >
                                                        Remover Cor
                                                    </Button>
                                                </Box>
                                            </Box>
                                        ) : isCopyingList ? (
                                            <Box sx={{ p: 2, maxWidth: '250px' }} ref={editRef}>
                                                <Typography sx={{
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    color: 'var(--text-primary, #172b4d)',
                                                    mb: 1.5,
                                                    textAlign: 'center'
                                                }}>
                                                    Copiar Lista
                                                </Typography>
                                                <TextField
                                                    id="outlined-multiline-static"
                                                    label="Nome da lista"
                                                    multiline
                                                    rows={3}
                                                    defaultValue={selectedListName}
                                                    onChange={handleTitleCopyList}
                                                    sx={{
                                                        width: '100%',
                                                        mb: 1.5,
                                                        '& .MuiOutlinedInput-root': {
                                                            backgroundColor: 'var(--textfield-bg-color, #fff)',
                                                            color: 'var(--textfield-text-color, #000)',
                                                            borderRadius: '6px',
                                                            fontSize: '14px',
                                                            '& fieldset': {
                                                                borderColor: 'var(--textfield-border-color, #ccc)',
                                                            },
                                                            '&:hover fieldset': {
                                                                borderColor: 'var(--textfield-hover-border-color, #aaa)',
                                                            },
                                                            '&.Mui-focused fieldset': {
                                                                borderColor: 'var(--textfield-focus-border-color, #009373)',
                                                                borderWidth: '2px',
                                                            },
                                                        },
                                                        '& .MuiInputLabel-root': {
                                                            color: 'var(--textfield-label-color, #000)',
                                                        },
                                                        '& .Mui-focused .MuiInputLabel-root': {
                                                            color: 'var(--textfield-label-focus-color, #009373)',
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            color: 'var(--textfield-text-color, #000)',
                                                            padding: '8px 10px',
                                                        },
                                                    }}
                                                    className="textfield"
                                                />
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => {
                                                            addList();
                                                            handlePopoverClose();
                                                        }}
                                                        className="button-popover-green"
                                                        sx={{
                                                            flex: 1,
                                                            fontSize: '13px',
                                                            fontWeight: 600,
                                                            textTransform: 'none',
                                                            borderRadius: '6px',
                                                            padding: '6px 12px',
                                                        }}
                                                    >
                                                        Copiar Lista
                                                    </Button>
                                                    <Button
                                                        variant="outlined"
                                                        onClick={handlePopoverClose}
                                                        className="button-cancel-popover"
                                                        sx={{
                                                            flex: 1,
                                                            fontSize: '13px',
                                                            fontWeight: 600,
                                                            textTransform: 'none',
                                                            borderRadius: '6px',
                                                            padding: '6px 12px',
                                                        }}
                                                    >
                                                        Cancelar
                                                    </Button>
                                                </Box>
                                            </Box>
                                        ) : (
                                            <Box sx={{ py: 0.5 }}>
                                                <Typography
                                                    sx={{
                                                        px: 2,
                                                        py: 1.5,
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        color: 'var(--text-primary, #172b4d)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                        '&:hover': {
                                                            backgroundColor: 'var(--bg-tertiary, #f4f5f7)',
                                                        },
                                                        transition: 'background-color 0.2s ease',
                                                    }}
                                                    className='option-edit-list'
                                                    onClick={(event) => handleEditListClick(event)}
                                                >
                                                    <EditIcon sx={{ fontSize: '16px', color: 'var(--text-secondary, #6b778c)' }} />
                                                    Editar Lista
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        px: 2,
                                                        py: 1.5,
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        color: 'var(--text-primary, #172b4d)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                        '&:hover': {
                                                            backgroundColor: 'var(--bg-tertiary, #f4f5f7)',
                                                        },
                                                        transition: 'background-color 0.2s ease',
                                                    }}
                                                    className='option-edit-list'
                                                    onClick={handleNewTitleClick}
                                                >
                                                    <ChecklistIcon sx={{ fontSize: '16px', color: 'var(--text-secondary, #6b778c)' }} />
                                                    Copiar Lista
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        px: 2,
                                                        py: 1.5,
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        color: 'var(--danger-color, #b04632)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                        '&:hover': {
                                                            backgroundColor: 'var(--danger-bg, #ffebe6)',
                                                        },
                                                        transition: 'background-color 0.2s ease',
                                                    }}
                                                    className='option-edit-list'
                                                    onClick={() => setDialogOpenLista(true)}
                                                >
                                                    <DeleteIcon sx={{ fontSize: '16px', color: 'var(--danger-color, #b04632)' }} />
                                                    Excluir Lista
                                                </Typography>
                                            </Box>
                                        )}
                                    </Popover>
                                    {!isCollapsed && (
                                        <>
                                            <Box className="column">
                                                <Box ref={droppableProvided.innerRef} width="100%" height="100%">
                                                    {items.map((item, idx) =>
                                                        item._type === 'note' ? (
                                                            <Note
                                                                key={`note-${item.note_id}`}
                                                                note={item}
                                                                index={idx}
                                                                openNoteModal={openNoteModal}
                                                                onUpdateNote={onUpdateNote}
                                                                backgroundColor={list.background_color}
                                                                isDarkMode={isDarkMode}
                                                                fetchNotes={fetchNotes}
                                                            // onDeleteNote={handleDeleteNote}
                                                            />
                                                        ) : (
                                                            <Card
                                                                key={`card-${item.id}`}
                                                                card={item}
                                                                index={idx}
                                                                coverColor={coverColor}
                                                                coverImage={coverImage}
                                                                openModal={(card) => openModal({ ...card, list_name: list.list_name })}
                                                                tagsInCards={tagsInCards}
                                                                commentsCount={commentsCount}
                                                                archivesCount={archivesCount}
                                                                progressTasks={progressTasks}
                                                                usersInCards={usersInCards}
                                                            />
                                                        )
                                                    )}
                                                </Box>
                                            </Box>
                                            <div className='column-add'>
                                                {provided.placeholder}
                                                <div className="add-card-container">
                                                    {addingCard.listId === list.list_id ? (
                                                        <div className="add-card-input-wrapper">
                                                            <TextField
                                                                value={addingCard.cardName}
                                                                onChange={handleCardNameChange}
                                                                onKeyPress={(e) => e.key === "Enter" && addingCard.cardName.trim() !== "" && handleCardNameKeyPress(e, list.list_id)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === "Escape") {
                                                                        setAddingCard({ listId: null, cardName: "" });
                                                                    }
                                                                }}
                                                                fullWidth
                                                                margin="normal"
                                                                autoFocus
                                                                onBlur={() => setAddingCard({ listId: null, cardName: "" })}
                                                                variant="outlined"
                                                                placeholder="Digite o nome do cartão"
                                                                sx={{
                                                                    '& .MuiOutlinedInput-root': {
                                                                        backgroundColor: 'var(--input-bg-color, #fff)',
                                                                        color: 'var(--input-text-color, #000)',
                                                                        '& fieldset': {
                                                                            borderColor: 'var(--input-border-color, #ccc)',
                                                                        },
                                                                        '&:hover fieldset': {
                                                                            borderColor: 'var(--input-hover-border-color, #aaa)',
                                                                        },
                                                                        '&.Mui-focused fieldset': {
                                                                            borderColor: 'var(--input-focus-border-color, #009373)',
                                                                        },
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        color: 'var(--input-text-color, #000)',
                                                                    },
                                                                }}
                                                            />
                                                        </div>
                                                    ) : addingNote && addingNote.listId === list.list_id ? (
                                                        <div className="add-card-input-wrapper">
                                                            <TextField
                                                                value={addingNote.noteName}
                                                                onChange={e => {
                                                                    handleNoteNameChange({
                                                                        ...e,
                                                                        target: {
                                                                            ...e.target,
                                                                            value: e.target.value.slice(0, 20)
                                                                        }
                                                                    });
                                                                }}
                                                                onKeyPress={(e) => e.key === "Enter" && addingNote.noteName.trim() !== "" && handleNoteNameKeyPress(e, list.list_id)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === "Escape") {
                                                                        setAddingNote({ listId: null, cardName: "" });
                                                                    }
                                                                }}
                                                                onBlur={() => setAddingNote({ listId: null, cardName: "" })}
                                                                fullWidth
                                                                margin="normal"
                                                                autoFocus
                                                                variant="outlined"
                                                                placeholder="Digite o título da nota"
                                                                inputProps={{ maxLength: 20 }}
                                                                sx={{
                                                                    '& .MuiOutlinedInput-root': {
                                                                        backgroundColor: 'var(--input-bg-color, #fff)',
                                                                        color: 'var(--input-text-color, #000)',
                                                                        '& fieldset': {
                                                                            borderColor: 'var(--input-border-color, #ccc)',
                                                                        },
                                                                        '&:hover fieldset': {
                                                                            borderColor: 'var(--input-hover-border-color, #aaa)',
                                                                        },
                                                                        '&.Mui-focused fieldset': {
                                                                            borderColor: 'var(--input-focus-border-color, #009373)',
                                                                        },
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        color: 'var(--input-text-color, #000)',
                                                                    },
                                                                }}
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                            {!showAddActions ? (
                                                                <Button
                                                                    className='button-add-card'
                                                                    startIcon={<AddIcon />}
                                                                    onClick={() => setShowAddActions(true)}
                                                                    style={{
                                                                        borderRadius: '5px',
                                                                        padding: '5px 10px',
                                                                        fontWeight: 'bold',
                                                                        transition: 'background-color 0.3s, color 0.3s',
                                                                        width: '100%',
                                                                        textTransform: 'uppercase',
                                                                        color: list.background_color
                                                                            ? lightenColor(list.background_color, 75)
                                                                            : 'inherit',
                                                                    }}
                                                                >
                                                                    Adicionar
                                                                </Button>
                                                            ) : (
                                                                <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
                                                                    <Button
                                                                        className='button-add-cartao'
                                                                        variant="contained"
                                                                        color="inherit"
                                                                        sx={{
                                                                            flex: 1,
                                                                            minWidth: 0,
                                                                            textTransform: 'capitalize',
                                                                            ...(list.background_color && { color: lightenColor(list.background_color, 75) })
                                                                        }}
                                                                        onClick={() => {
                                                                            handleAddCardClick(list.list_id);
                                                                            setShowAddActions(false);
                                                                        }}
                                                                    >
                                                                        Cartão
                                                                    </Button>
                                                                    <Button
                                                                        className='button-add-cartao'
                                                                        variant="contained"
                                                                        color="inherit"
                                                                        sx={{
                                                                            flex: 1,
                                                                            minWidth: 0,
                                                                            textTransform: 'capitalize',
                                                                            ...(list.background_color && { color: lightenColor(list.background_color, 75) })
                                                                        }}
                                                                        onClick={() => handleAddNoteClick(list.list_id)}
                                                                    >
                                                                        Nota
                                                                    </Button>
                                                                    <Button
                                                                        className='button-add-cartao'
                                                                        variant="contained"
                                                                        color="inherit"
                                                                        sx={{
                                                                            minWidth: 0,
                                                                            px: 1,
                                                                            textTransform: 'none',
                                                                            ...(list.background_color && { color: lightenColor(list.background_color, 75) })
                                                                        }}
                                                                        onClick={() => setShowAddActions(false)}
                                                                        title="Cancelar"
                                                                    >
                                                                        ✕
                                                                    </Button>
                                                                </Box>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {/* {isCollapsed && droppableProvided.placeholder}
                                    {!isCollapsed && droppableProvided.placeholder} */}
                                    {provided.placeholder}
                                </Box>
                            )}
                        </StrictModeDroppable>
                    )}
                    <ConfirmationDialog
                        open={dialogOpenLista}
                        onClose={() => setDialogOpenLista(false)}
                        onConfirm={() => handleDeleteList(selectedListId)}
                        title="Confirmar Exclusão"
                        message="Tem certeza de que deseja excluir a lista? Esta ação não pode ser desfeita."
                    />

                </Box>
            )}
        </Draggable>
    );
}

export default CardList;